import React from 'react';
import style from './smallesttitle.module.css';

const SmallestTitle = ({ children, customClass}) => {
    return (
      <h4 className={customClass}>{children}</h4>
    );
};

export default SmallestTitle;